import React from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { useSelector } from 'react-redux';
import moment from 'moment';
import { getFromLocalStorage } from 'helpers/LocalStorage';
// Components
import CustomButton from './CustomButton';
import BackIcon from 'assets/images/svg/BackIcon';
import FlowardLogo from 'assets/images/svg/FlowardLogo';
import ReloadIcon from 'assets/images/svg/ReloadIcon';
import NotificationButton from './NotificationButton';
import NoDeviationNotifications from './NoDeviationNotifications';
import UrgentExpressButton from './UrgentExpressButton';
import HeaderSearch from './HeaderSearch';
import HeaderUser from './HeaderUser';
import ShiftToggle from './ShiftToggle';
// Helpers
import { reloadPage, handleBack, convertQueryParamsIntoObject } from 'constants/Helpers';
// Selectors
import { getExpressOrdersCount } from 'store/app/AppSelectors';

// Pages that carry the orders / production search box.
const SEARCHABLE_PAGES = ['home', 'orders', 'my-task', 'production'];
// Pages reached from the orders list - they get a back button next to the brand.
// orderdetails carries its own back button in the page top bar.
const BACKABLE_PAGES = ['orders', 'my-task', 'jobdetails', 'qualitycheck'];
// Pages whose back button goes straight home rather than into browser history.
const HOME_BACK_PAGES = ['prod-jobs', 'completed-orders'];

const Header = () => {
  const navigate = useNavigate(),
    location = useLocation(),
    params = location.search ? convertQueryParamsIntoObject(location.search) : {},
    currentPage = location.pathname.split('/')[1] || 'home',
    opsID = getFromLocalStorage('opsId'),
    deviationEnabled = true,
    expressCount = useSelector((state) => getExpressOrdersCount({ state }));

  const isCompletedOrders = currentPage === 'completed-orders';
  const goesHome = HOME_BACK_PAGES.includes(currentPage);
  const showBack = goesHome || BACKABLE_PAGES.includes(currentPage);

  return (
    <div className="header-wrapper hf-main-header no-bottom-margin">
      <div className="header-left-column">
        {showBack && (
          <CustomButton
            id="header-back"
            handleClick={() => (goesHome ? navigate('/home') : handleBack())}
            type="header-icon"
            fontAwsome={<BackIcon />}
          />
        )}
        <button type="button" className="app-brand" onClick={() => navigate('/home')}>
          <FlowardLogo cssClass="app-brand-logo" />
        </button>
        {isCompletedOrders && (
          <h5 className="header-selected-date">
            {moment(params.deliveryDate).format('DD/MM/YYYY')}
          </h5>
        )}
      </div>

      <div className="header-center-column">
        {SEARCHABLE_PAGES.includes(currentPage) && <HeaderSearch />}
      </div>

      <div className="header-right-column">
        {!isCompletedOrders && (
          <>
            <UrgentExpressButton count={expressCount} />
            <span className="header-divider" />
            {deviationEnabled ? <NotificationButton /> : <NoDeviationNotifications />}
            <span className="header-divider" />
          </>
        )}
        <button
          type="button"
          className="header-icon-btn"
          title="Refresh"
          onClick={() => reloadPage()}
        >
          <ReloadIcon />
        </button>
        <ShiftToggle />
        <HeaderUser />
      </div>
    </div>
  );
};

export default Header;
